import React from 'react';

import { usePriceRowContext } from '../../../price-row-context';

import { IconVerfied } from '@prisjakt/ui/icon';
import { BodySmallText } from '@prisjakt/ui/text/variants';
import { useAppContext } from '@prisjakt/ui-app-context';
import { Tooltip } from '@prisjakt/ui/tooltip';
import { Direction } from '@prisjakt/ui';
import { MediumUp, MobileOnly } from 'src/ui/block';

import { StyledBadge } from './styles';

type Props = {
  className?: string;
};

export const AuthorizedDealerBadge: React.FC<Props> = ({ className }) => {
  const { offer, brand } = usePriceRowContext();
  const { t } = useAppContext();

  const content = (
    <>
      <MobileOnly>
        <StyledBadge circular color="BLUE" icon={IconVerfied} />
      </MobileOnly>

      <MediumUp>
        <StyledBadge
          color="BLUE"
          icon={IconVerfied}
          text={
            <BodySmallText weight={600} style={{ fontSize: 12 }}>
              {t('store', 'brand.recommended-retailer')}
            </BodySmallText>
          }
        />
      </MediumUp>
    </>
  );

  if (!brand || !offer.store) {
    return content;
  }

  return (
    <Tooltip
      className={className}
      title={t('store', 'store.recommended-retailer-brand', {
        brand: brand.name,
        store: offer.store.name,
      })}
      placement={Direction.Left}
    >
      {content}
    </Tooltip>
  );
};
